import { useEffect, useState, useRef } from "react";

import styles from "./Face3.module.scss";

export default function Face3() {
  const cardRef = useRef<HTMLDivElement>(null);

  const [fontSize, setFontSize] = useState<number | undefined>(undefined);
  const [letterSpacing, setLetterSpacing] = useState<number | undefined>(
    undefined,
  );
  const [lineHeight, setLineHeight] = useState<number | undefined>(undefined);
  const [marginLeft, setMarginLeft] = useState<number | undefined>(undefined);

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      if (cardRef.current) {
        setFontSize(Math.floor(0.04 * cardRef.current.clientWidth));
        setLetterSpacing(0.002 * cardRef.current.clientWidth);
        setLineHeight(0.05 * cardRef.current.clientWidth);
        setMarginLeft(0.4 * cardRef.current.clientWidth);
      }
    }

    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount

  return (
    <div ref={cardRef} className={styles.card}>
      <div
        style={{
          fontSize: `${fontSize}px`,
          letterSpacing: `${letterSpacing}px`,
          lineHeight: `${lineHeight}px`,
          marginLeft: `${marginLeft}px`,
          width: "100%",
        }}
      >
        <p>To je kao šetnja gustom šumom</p>
        <p>iznenadno prekinuta čistinom</p>
        <p>s očitim oltarom</p>
        <br></br>
        <p>To je let u malom avionu</p>
        <p>prevrtanje delirija i želje za smrću</p>
        <p>dok bruji motorom</p>
        <br></br>
        <p>Isto kao stajati u Sainte-Chapelle</p>
        <p>i dobiti tako ugodnu potvrdu</p>
        <p>o vlastitoj nevažnosti</p>
        <br></br>
        <p>To smo mi dok cucamo zelene šljive</p>
        <p>u pokušaju pariranja HC izgaranja</p>
        <p>ove naše mladosti</p>
        <br></br>
        <p>To sam ja koja te volim tako jako</p>
        <p>Dok ti ne odlučiš voljeti natrag</p>
        <p>Ali Uh i tako Kasno</p>
        <p>ogromno-sitna greška.</p>
      </div>
    </div>
  );
}
